<template>
    <div>
        <div v-if="!isLoggedIn" class="topbar navbar navbar-default">
            <div class="navbar-header">
                <div class="navbar-header-wrapper u-flex-center">
                    <router-link :to="{ name: 'home' }" class="link-no-decoration">
                        <h1>{{ trans('page.site-title') }}</h1>
                    </router-link>
                    <div class="u-vertical-separated-line | u-display--none-portable"></div>
                </div>
            </div>
        </div>
        <div class="error-page">
            <div class="container">
                <div class="page-block">
                    <div class="page-block__item-wrapper">
                        <h1 class="alpha | u-text-color-primary u-text-center">
                            {{ trans('error.404.title') }}
                        </h1>
                        <p class="u-text-center" v-html="trans('error.404.description')" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { pageLoadingStatusMixin } from 'relapp-loading';
import { mapGetters } from 'vuex';

export default {
    mixins: [pageLoadingStatusMixin],
    computed: {
        ...mapGetters({
            isLoggedIn: 'user/isLoggedIn'
        })
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
    }
};
</script>
